/* Switched On knowledge centre (15 Oct 2026): behaviour for sections/kc-guide.liquid (every guide) and
   sections/kc-hub.liquid (/pages/advice). Styles: assets/kc.css.

   Ask Otto      [data-kc-otto]            opens Otto (the euronics-ai app): window.EuronicsAI.open(), else the app's
                                           launcher. Otto buttons and rows ([data-kc-otto], [data-kc-otto-row]) start
                                           hidden and appear only when the app says Otto is on for this page type
                                           (GET /apps/euronics-ai/v1/config?pageType=article|page, enabled: true),
                                           so there is never a button that cannot answer.
   Shop tabs     [data-kc-tab] / [data-kc-tabp]       Our picks / By type / Goes with in the Shop this guide box.
   Types         [data-kc-type] tiles open [data-kc-type-panel] (the in-stock products of that type, under the
                 tiles); [data-kc-type-open] rows (right-hand column, phone sheet) open the same panel and scroll to it.
   Phone sheet   [data-kc-sheet-open] moves the Shop this guide box into [data-kc-sheet] (one copy of the products
                 in the page); closing puts it back. The bar [data-kc-sbar] shows once the reader is past the header
                 and hides when the full-width Shop this guide (or the end of the guide) comes into view.
   Progress      [data-kc-progress] = how far through the guide the reader is.
   Hub search    [data-kc-search] + [data-kc-chip]: Shopify's predictive search, articles only, results inline.
   Hub tools     [data-kc-cost] running cost, [data-kc-dehum] dehumidifier size. */
(function () {
  'use strict';
  var d = document, w = window;
  var root = d.querySelector('.kc');
  if (!root) return;
  function all(s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  var design = !!(w.Shopify && w.Shopify.designMode);

  /* ---------- Ask Otto ---------- */
  var ottoEls = all('[data-kc-otto], [data-kc-otto-row]');
  if (ottoEls.length) {
    if (design) {
      ottoEls.forEach(function (e) { e.hidden = false; });
    } else {
      var pt = root.getAttribute('data-kc-page-type') || 'page';
      fetch('/apps/euronics-ai/v1/config?pageType=' + encodeURIComponent(pt), { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (c) { if (c && c.enabled === true) ottoEls.forEach(function (e) { e.hidden = false; }); })
        .catch(function () {});
    }
  }
  function ottoOpen(opts, el) {
    if (el) opts.opener = el;
    if (w.EuronicsAI && typeof w.EuronicsAI.open === 'function') { w.EuronicsAI.open(opts); return true; }
    var l = d.querySelector('.eai-launcher__open');
    if (l) { l.click(); return true; }
    return false;
  }
  d.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-kc-otto]') : null;
    if (!b) return;
    if (ottoOpen({ source: b.getAttribute('data-kc-otto-source') || 'advice' }, b)) { e.preventDefault(); closeSheet(true); }
  });

  /* ---------- Shop this guide tabs ---------- */
  all('[data-kc-shopbox]').forEach(function (box) {
    var tabs = all('[data-kc-tab]', box);
    if (!tabs.length) return;
    function select(k, focus) {
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-kc-tab') === k;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        if (on && focus) t.focus();
      });
      all('[data-kc-tabp]', box).forEach(function (p) { p.hidden = p.getAttribute('data-kc-tabp') !== k; });
    }
    tabs.forEach(function (t, i) {
      t.tabIndex = t.getAttribute('aria-selected') === 'true' ? 0 : -1;
      t.addEventListener('click', function () { select(t.getAttribute('data-kc-tab')); });
      t.addEventListener('keydown', function (e) {
        var n = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!n) return;
        e.preventDefault();
        select(tabs[(i + n + tabs.length) % tabs.length].getAttribute('data-kc-tab'), true);
      });
    });
  });

  /* ---------- Shop by type panels ---------- */
  var tiles = all('[data-kc-type]');
  function setType(k) {
    tiles.forEach(function (t) { t.setAttribute('aria-expanded', t.getAttribute('data-kc-type') === k ? 'true' : 'false'); });
    all('[data-kc-type-panel]').forEach(function (p) { p.hidden = p.getAttribute('data-kc-type-panel') !== k; });
  }
  tiles.forEach(function (t) {
    t.addEventListener('click', function () {
      var k = t.getAttribute('data-kc-type');
      setType(t.getAttribute('aria-expanded') === 'true' ? null : k);
    });
  });
  d.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('[data-kc-type-open]') : null;
    if (!a) return;
    e.preventDefault();
    var k = a.getAttribute('data-kc-type-open');
    closeSheet(false);
    setType(k);
    var row = d.querySelector('.kc-types5') || d.getElementById('kc-tp-' + k);
    if (row) row.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  /* ---------- phone: Shop this guide sheet and bar ---------- */
  var sheet = d.querySelector('[data-kc-sheet]');
  var scrim = d.querySelector('[data-kc-scrim]');
  var bar = d.querySelector('[data-kc-sbar]');
  var box = d.querySelector('[data-kc-shopbox]');
  var home = box ? box.parentNode : null;
  var homeNext = box ? box.nextSibling : null;
  var lastFocus = null;
  function openSheet() {
    if (!sheet || !box) return;
    lastFocus = d.activeElement;
    sheet.appendChild(box);
    sheet.hidden = false;
    if (scrim) scrim.hidden = false;
    d.documentElement.classList.add('kc-lock');
    var x = box.querySelector('[data-kc-sheet-close]');
    if (x) x.focus();
  }
  function closeSheet(refocus) {
    if (!sheet || sheet.hidden) return;
    sheet.hidden = true;
    if (scrim) scrim.hidden = true;
    d.documentElement.classList.remove('kc-lock');
    if (home && box) home.insertBefore(box, homeNext && homeNext.parentNode === home ? homeNext : null);
    if (refocus !== false && lastFocus && lastFocus.focus) lastFocus.focus();
  }
  d.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    if (e.target.closest('[data-kc-sheet-open]')) { e.preventDefault(); openSheet(); }
    else if (e.target.closest('[data-kc-sheet-close]') || e.target.closest('[data-kc-scrim]')) { e.preventDefault(); closeSheet(); }
  });
  d.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSheet(); });
  if (sheet) {
    sheet.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var f = all('a[href],button:not([disabled]),input,[tabindex]:not([tabindex="-1"])', sheet).filter(function (x) { return x.offsetParent !== null; });
      if (!f.length) return;
      if (e.shiftKey && d.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && d.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    });
  }

  var art = d.getElementById('kc-article');
  var ah = d.querySelector('.kc-ah');
  var sa = d.querySelector('.kc-sa');
  var prog = d.querySelector('[data-kc-progress]');
  var jumps = all('.kc-jump a');
  var ticking = false;
  if (bar) { bar.hidden = false; bar.classList.add('is-off'); }
  function onScroll() {
    ticking = false;
    var vh = w.innerHeight;
    if (art && prog) {
      var r = art.getBoundingClientRect();
      var p = Math.min(1, Math.max(0, -r.top / Math.max(1, r.height - vh * 0.6)));
      prog.style.setProperty('--p', p.toFixed(4));
    }
    if (bar) {
      var past = ah ? ah.getBoundingClientRect().bottom < 0 : w.pageYOffset > 400;
      var before = sa ? sa.getBoundingClientRect().top > vh : (art ? art.getBoundingClientRect().bottom > vh * 0.5 : true);
      bar.classList.toggle('is-off', !(past && before) || (sheet && !sheet.hidden));
    }
    if (jumps.length) {
      var cur = null;
      jumps.forEach(function (a) {
        var t = d.getElementById(a.getAttribute('href').slice(1));
        if (t && t.getBoundingClientRect().top < 140) cur = a;
      });
      jumps.forEach(function (a) { a.classList.toggle('on', a === cur); });
    }
  }
  if (art || bar) {
    w.addEventListener('scroll', function () { if (!ticking) { ticking = true; w.requestAnimationFrame(onScroll); } }, { passive: true });
    w.addEventListener('resize', function () { if (w.innerWidth >= 990) closeSheet(false); onScroll(); });
    onScroll();
  }

  /* ---------- hub: guide search ---------- */
  var form = d.querySelector('[data-kc-search]');
  var q = d.querySelector('[data-kc-q]');
  var res = d.querySelector('[data-kc-results]');
  var chips = all('[data-kc-chip]');
  var seq = 0, timer = null;
  var KINDS = { 'buying-guides': 'Buying guide', 'head-to-head-comparisons': 'Head to head', 'tips-how-to-guides': 'How to', 'maintenance-guides': 'Care & repair', 'latest-news': 'News', 'latest-industry-news': 'News' };
  function kindOf(url) { var m = /\/blogs\/([^/]+)\//.exec(url || ''); return (m && KINDS[m[1]]) || 'Feature'; }
  function clearResults() {
    seq++;
    if (res) { res.hidden = true; res.innerHTML = ''; }
    chips.forEach(function (c) { c.setAttribute('aria-pressed', 'false'); });
  }
  function draw(list, term) {
    if (!res) return;
    var h = '<div class="kc-results__hd"><b>' + (list.length ? list.length + (list.length === 1 ? ' guide' : ' guides') + ' for “' + esc(term) + '”' : 'No guides for “' + esc(term) + '” yet') + '</b><button type="button" data-kc-clear>Clear</button></div>';
    if (list.length) {
      h += '<div class="kc-results__g">' + list.map(function (a) {
        var img = a.image ? String(a.image) : '';
        var crop = /-euronics\./i.test(img);
        if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=240';
        return '<a href="' + esc(a.url) + '"><span>' + (img ? '<img class="kc-img' + (crop ? ' kc-crop' : '') + '"' + (crop ? ' style="--kz:1.6"' : '') + ' src="' + esc(img) + '" alt="" loading="lazy">' : '') + '</span><span><span class="kc-meta">' + esc(kindOf(a.url)) + '</span><b>' + esc(a.title) + '</b></span></a>';
      }).join('') + '</div>';
    } else {
      h += '<p class="kc-results__none">Try a shorter word, or ask our team in store.</p>';
    }
    res.innerHTML = h;
    res.hidden = false;
  }
  function search(term) {
    term = (term || '').trim();
    if (term.length < 2) { clearResults(); return; }
    var my = ++seq;
    var url = '/search/suggest.json?q=' + encodeURIComponent(term) + '&resources[type]=article&resources[limit]=10&resources[options][fields]=title,tag,body';
    fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        if (my !== seq) return;
        var list = (j && j.resources && j.resources.results && j.resources.results.articles) || [];
        draw(list, term);
      })
      .catch(function () {});
  }
  if (form && q) {
    q.addEventListener('input', function () {
      chips.forEach(function (c) { c.setAttribute('aria-pressed', 'false'); });
      clearTimeout(timer);
      timer = setTimeout(function () { search(q.value); }, 220);
    });
    form.addEventListener('submit', function (e) { e.preventDefault(); clearTimeout(timer); search(q.value); });
  }
  chips.forEach(function (c) {
    c.setAttribute('aria-pressed', 'false');
    c.addEventListener('click', function () {
      var on = c.getAttribute('aria-pressed') === 'true';
      if (on) { if (q) q.value = ''; clearResults(); return; }
      chips.forEach(function (x) { x.setAttribute('aria-pressed', x === c ? 'true' : 'false'); });
      var t = c.getAttribute('data-kc-chip');
      if (q) q.value = t;
      search(t);
    });
  });
  if (res) res.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-kc-clear]')) { if (q) { q.value = ''; q.focus(); } clearResults(); }
  });

  /* ---------- hub: tools ---------- */
  function seg(group, onPick) {
    var bs = all('[role="radio"]', group);
    bs.forEach(function (b, i) {
      b.tabIndex = b.getAttribute('aria-checked') === 'true' ? 0 : -1;
      b.addEventListener('click', function () { pick(b); });
      b.addEventListener('keydown', function (e) {
        var n = e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : e.key === 'ArrowLeft' || e.key === 'ArrowUp' ? -1 : 0;
        if (!n) return;
        e.preventDefault();
        var t = bs[(i + n + bs.length) % bs.length]; pick(t); t.focus();
      });
    });
    function pick(b) {
      bs.forEach(function (x) { x.setAttribute('aria-checked', x === b ? 'true' : 'false'); x.tabIndex = x === b ? 0 : -1; });
      onPick(b);
    }
  }
  var cost = d.querySelector('[data-kc-cost]');
  if (cost) {
    var out = cost.querySelector('[data-kc-cost-out]'), rate = cost.querySelector('[data-kc-rate]');
    var groups = all('.kc-seg', cost);
    function val(attr) { var b = cost.querySelector('[' + attr + '][aria-checked="true"]'); return b ? parseFloat(b.getAttribute(attr)) : 0; }
    function calc() {
      var r = parseFloat(rate && rate.value) || 0;
      var day = val('data-kw') * val('data-hr') * r / 100;
      out.textContent = '€' + day.toFixed(2) + ' a day';
    }
    groups.forEach(function (g) { seg(g, calc); });
    if (rate) rate.addEventListener('input', calc);
    calc();
  }
  var dh = d.querySelector('[data-kc-dehum]');
  if (dh) {
    var dout = dh.querySelector('[data-kc-dehum-out]');
    all('.kc-seg', dh).forEach(function (g) { seg(g, function (b) { dout.textContent = b.getAttribute('data-out'); }); });
  }
})();
